export default __webpack_public_path__ + "static/media/ruby-red-grapefruit@3x.c416ea8a.png";